jQuery(document).ready(function () {

  /**
   * Confirm the company contacts action.
   *
   * @param formEl$
   * @returns {boolean}
   */
  function confirmAction(formEl$) {
    let buttonLabel$ = formEl$.find('.js-agend-company-contacts-button__label');
    if (!buttonLabel$.length) {
      return confirm('Are you sure?');
    }

    let action = buttonLabel$.data('action');
    if( action.length === 0) {
      return confirm('Are you sure?');
    }

    return confirm(`Are you sure you want to ${action}?`);
  }

  /**
   * Confirm the action is what the user wants before submitting the form.
   */
  jQuery('.js-remove-contact-form')
    .add('.js-revoke-company-admin-form, .js-grant-company-admin-form')
    .on('submit', function () {
      return confirmAction(jQuery(this));
    });
});
